/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Chip_AddInputs */

const vi_shop_chip_add = /** @type {(inputs: Shop_Chip_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Thêm`)
};

/**

* @param {Shop_Chip_AddInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_chip_add = /** @type {((inputs?: Shop_Chip_AddInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Chip_AddInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_chip_add(inputs)
});